exports.STATUS_COTACAO = {
  EM_ABERTO: 1,
  RECUSADA: 2,
  AGUARDANDO_APROVACAO: 3,
  FINALIZADA: 4,
  PENDENTE: 5,
  EM_PROCESSO_VISTORIA: 6,
  EM_PRE_ANALISE: 7,
};
